module.exports = __webpack_public_path__ + "img/member_shopping_online_icon_431006.0682f4f7.png";